export default "__VITE_ASSET__DXdXTVZf__"